
        Component.define('where-to-find-snack-dental', (el, params) => {
            /**
 * O componente Each recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

$el = $(el);

$el.find('.list-buy-online a').on('click', function(e){
    const url = $(this).attr('href');
    $document.trigger('ga-comprar-online:click', [url])
});

$el.find('.list-where-to-find a').on('click', function(e){
    e.preventDefault();

    Navigation.helpers.scrollTo($el.find('.box-cep'));

    $el.find('.box-cep [name="cep"]').focus();
});
        });